'use strict';

(function() {
	angular.module('onboarding.internaladmin')
		.directive('cobAssureSignIdModal', cobAssureSignIdModal);

	cobAssureSignIdModal.$inject = ['internalAdminService', 'validationService'];
	var internalAdminService, validationService;

	function cobAssureSignIdModal(_internalAdminService_, _validationService_) {

		internalAdminService = _internalAdminService_;
		validationService = _validationService_;

		return {
			restrict: 'E',
			scope: {
				brokerId: '=',
				closeFn: '&',
				companyName: '=',
				domain: '='
			},
			replace: true,
			templateUrl: '/app/internaladmin/cobAssureSignIdModal.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			scope.cancelClicked = cancelClicked;
			scope.saveClicked = saveClicked;

			scope.$watch('brokerId',
				function() {
					if (scope.brokerId > 0) {
						getAssureSignContext();
					}
				});
		}

		function cancelClicked() {
			scope.brokerId = 0;
			scope.closeFn()();
		}

		function getAssureSignContext() {
			internalAdminService.identifyBroker(scope.domain)
				.then(function(response) {
					scope.brokerIdentity = response.data;
				})
				.catch(function(e) {
					console.print(e);
				});

			return;
		}

		function saveClicked() {
			validateEmail();
			if (scope.assureSignUserIdError)
				return;
			internalAdminService.defineOnboardingBroker(scope.brokerIdentity)
				.then(function() {
					// all is good
					scope.closeFn()();
				})
				.catch(function(e) {
					console.print(e);
				});
		}

		function validateEmail() {
			if (scope.brokerIdentity.assureSignUserId &&
                !validationService.isValidEmail(scope.brokerIdentity.assureSignUserId)) {
				scope.assureSignUserIdError = 'Valid email is required';
			} else {
				delete scope.assureSignUserIdError;
			}
		}
	}
})();
